/* eslint-disable */
import React from "react";
import { HierarchyControl, HierarchyControlItem } from '../../../../basf-ui';
import { useDictionary, useParameter } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";

interface ControlItem extends HierarchyControlItem<number> {

}

export const ReferenceYearControl: React.FC = () => {
  const [controlItems, setControlItems] = React.useState<ControlItem[]>([]);
  const [loadingValue, setLoadingValue] = React.useState<boolean>(true);
  const [refYearvalue, setRefYearValue] = useParameter<number | null>("@ref_year");

  const [dictItems, dict, dictLoading] = useDictionary(dictionaryService, "slides-reference-year-slide-34");

  React.useEffect(
    function updateControlItems() {
      setLoadingValue(true);
      if (dictItems) {
        const nextControlItems = dictItems.map<ControlItem>((dictItem) => ({
          id: Number(dictItem.id),
          name: dictItem.getValue<Record<number, string>>("name")?.[9] || "",
        }));
        setControlItems(nextControlItems);

        let selectedItem = nextControlItems.find((item) => item.id === refYearvalue);
        if (selectedItem === undefined && nextControlItems[0]) {
          const firstItem = nextControlItems[0];
          setRefYearValue(firstItem.id);
        }
        setLoadingValue(false);
      }
    },
    [dictItems],
  );

  const handlerChange = React.useCallback(
    (selectedId: number | undefined) => selectedId && setRefYearValue(selectedId),
    [],
  );

  const loading = loadingValue || dictLoading;

  return <HierarchyControl label="Reference year" value={refYearvalue as number | undefined} onChange={handlerChange} items={controlItems} loading={loading}/>
};
